import {
  type Verdict,
  type GetExamCenterProctorRequestVerdictsByIdQuery,
} from '@exam-center/graphql';
import { formatDateTime } from '@shared/utils';

export function getProctorRequestVerdictCardProps(
  requestVerdict: GetExamCenterProctorRequestVerdictsByIdQuery['ecGetExamCenterProctorRequestById']['examCenterProctorRequest']['verdicts'][number],
) {
  const comment =
    requestVerdict.comment && requestVerdict.comment.length > 0 ? requestVerdict.comment : '-';
  const submittedAt = formatDateTime(requestVerdict.submittedAt);
  const verdict = requestVerdict.verdict as Verdict;
  return { comment, submittedAt, verdict };
}
